import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var MailIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M38.76 11H9.48999C8.29733 11.0027 7.15425 11.4776 6.31091 12.3209C5.46757 13.1643 4.99263 14.3073 4.98999 15.5V32.63C4.98999 33.9004 5.49465 35.1187 6.39294 36.017C7.29124 36.9153 8.50964 37.42 9.78003 37.42H38.78C39.9735 37.42 41.1181 36.9459 41.962 36.102C42.8059 35.2581 43.28 34.1135 43.28 32.92V15.5C43.2787 14.9077 43.1607 14.3215 42.9329 13.7749C42.705 13.2282 42.3717 12.7318 41.952 12.3139C41.5322 11.8961 41.0344 11.5649 40.4867 11.3395C39.939 11.1141 39.3523 10.9987 38.76 11ZM24.13 23.76L10.21 13.5H38.55L24.13 23.76ZM40.76 32.92C40.76 33.4504 40.5493 33.9592 40.1742 34.3342C39.7991 34.7093 39.2904 34.92 38.76 34.92H9.76001C9.15347 34.9174 8.5725 34.6752 8.14362 34.2463C7.71473 33.8175 7.4726 33.2366 7.46997 32.63V15.5C7.47181 15.2321 7.52621 14.967 7.63 14.72L22.72 25.84C23.1165 26.1512 23.606 26.3202 24.11 26.32C24.5862 26.3215 25.0499 26.1669 25.43 25.88L40.68 15.05C40.716 15.1974 40.7361 15.3483 40.74 15.5L40.76 32.92Z"
  }));
});
MailIcon.displayName = 'MailIcon';
MailIcon.defaultProps = {
  'aria-label': 'Mail'
};
export default MailIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/MailIcon/index.js
// module id = 1885
// module chunks = 12